import React from 'react';
import 'sections/styles/ServicesSection.css';

const ServicesSection: React.FC = () => {
	return (
		<section id="services" className="services-section">
			<h2 className="section-title">Our Services</h2>
			<div className="services-container">
				<div className="service-card">
					
					<h3>Land Clearing</h3>
					<p>Our herd will efficiently clear unwanted vegetation and undergrowth without heavy machinery or chemicals.</p>
				</div>

				<div className="service-card">
					
					<h3>Invasive Plant Removal</h3>
					<p>Our goats love eating invasive plants like kudzu, poison ivy, and brambles.</p>
				</div>

				<div className="service-card">
					
					<h3>Fire Prevention</h3>
					<p>By eating dry grasses and brush, our goats reduce the amount of flammable material, lowering wildfire risk.</p>
				</div>
			</div>
		</section>
	);
};

export default ServicesSection;
